export default __webpack_public_path__ + "static/media/box-3.7f24f36f.png";